import React from 'react';
import { Link } from 'react-router-dom';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';

import store from 'Redux/store';
import Meta from 'Components/Utility/SEO/Meta';

const messages = defineMessages({
  title: {
    id: 'ordernotfound.title',
    defaultMessage: 'Order Not Found',
  },
});

function NotFound({ intl }) {
  const { formatMessage } = intl;
  store.dispatch({ type: 'frontend/not-found/NOT_FOUND', payload: { notFound: true } });

  return (
    <div className="py-5">
      <Meta title={formatMessage(messages.title)} />
      <div className="text-center container">
        <h1 className="text-primary">
          <FormattedMessage id="ordernotfound.header" defaultMessage="Order Not Found" />
        </h1>
        <p className="mt-5">
          <FormattedMessage
            id="ordernotfound.content"
            defaultMessage="The order you're looking for could not be found in your account. See  {homePageLink}"
            values={{
              homePageLink: <Link to="/orders" className="text-primary">
                <FormattedMessage id="ordernotfound.homePageLink" defaultMessage="all of your orders" />
              </Link>,
            }}
          />
        </p>
      </div>
    </div>
  );
}

export default injectIntl(NotFound);
